<template>
    <div id="reference" class="section">
        <h1 class="header">{{ $t("reference.header") }}<span class="header-dot">.</span></h1>
        <h3 class="introduction">{{ $t("reference.introduction") }}</h3>
        <div class="header-separator"></div>
        <div class="content">
            <div class="logo-row">
                <a href="https://www.burgerking.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/burgerking.png" alt="client_logo">
                </a>
                <a href="https://www.marche-movenpick.hr/hr" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/marche.png" alt="client_logo">
                </a>
                <a href="https://pizzahut.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/pizza-hut.png" alt="client_logo">
                </a>
                <a href="https://biberon.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/biberon.png" alt="">
                </a>
                <a href="https://prvca.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/prvca.svg" alt="">
                </a>
                <a href="https://www.pharmanet.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/pharmanet.jpg" alt="client_logo">
                </a>
                <a href="https://ljekarna-jadran.hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/ljekarna-jadran.png" alt="client_logo">
                </a>
                <a href="https://www.slaj-anic.com/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/slaj-anic.png" alt="">
                </a>
                <a href="https://www.rfuni.com/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/rapidfire-unicorn.png" alt="client_logo">
                </a>
                <a href="https://www.noa-zrce.com/en" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/noa.svg" alt="">
                </a>
                <a href="https://www.coralbeachmyrtlebeachresort.com/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/coral-beach.png" alt="">
                </a>
                <a href="https://www.tui.co.uk/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/tui.svg" alt="">
                </a>
                <a href="https://www.royaldubrovnik.com/hr/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/royal-dubrovnik.png" alt="">
                </a>
                <a href="https://b2b.bookmeatable.com/" target="_blank">
                    <img class="logo-large" src="../../../assets/images/clients/book-me-a-table.svg" alt="">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    #reference {
        
    }
</style>